/* eslint-disable no-console */

type LogArgs = unknown[]

const debug = (...args: LogArgs) => {
    if (process.env.NODE_ENV !== 'production') {
        console.log(...args)
    }
}

export const logger = {
    debug,
    warn: (...args: LogArgs) => console.warn(...args),
    error: (...args: LogArgs) => console.error(...args),
} as const
